import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthServiceFacade } from "@pcp/auth";
import { validate } from "uuid";
import { AsyncPipe } from "@angular/common";
import { LoginLoadingComponent } from "live-lesson/shared/feature-shell";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [AsyncPipe, LoginLoadingComponent]
})
export class LoginComponent implements OnInit {

    private readonly route = inject(ActivatedRoute);
    private readonly auth = inject(AuthServiceFacade);

    readonly isLoggingIn$ = this.auth.isLoggingIn$;
    readonly loginError$ = this.auth.loginFailedReason$;

    private readonly authService = inject(AuthServiceFacade);

    loginError?: string;

    private readonly liveLessonParamKey = 'liveLessonId';
    private readonly liveLessonLoginTokenParamKey = 'token';

    ngOnInit() {
        // JSON encoded jwt token provided via URL.
        const encodedLiveLessonId = this.route.snapshot.paramMap.get(this.liveLessonParamKey);
        const encodedLiveLessonLoginToken = this.route.snapshot.queryParamMap.get(this.liveLessonLoginTokenParamKey);

        const params = this.route.snapshot.paramMap.keys;
        const queryParams = this.route.snapshot.queryParamMap.keys;

        const liveLessonId = encodedLiveLessonId ? decodeURIComponent(encodedLiveLessonId) : undefined;
        const liveLessonLoginToken = encodedLiveLessonLoginToken ? decodeURIComponent(encodedLiveLessonLoginToken) : undefined;

        // TODO: try...catch
        if (typeof liveLessonLoginToken !== 'string' || typeof liveLessonId !== 'string' || !validate(liveLessonId)) {
            throw 'invalid token';
        }

        this.authService.authLiveLessonModerator(liveLessonId, liveLessonLoginToken);
    }

}
